var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2084 0.916626H3.79175C2.20393 0.916626 0.916748 2.20381 0.916748 3.79163V5.70829C0.916748 6.23757 1.34581 6.66663 1.87508 6.66663H2.83341V17.2083C2.83341 18.7961 4.1206 20.0833 5.70842 20.0833H15.2917C16.8796 20.0833 18.1667 18.7961 18.1667 17.2083V6.66663H19.1251C19.6544 6.66663 20.0834 6.23757 20.0834 5.70829V3.79163C20.0834 2.20381 18.7962 0.916626 17.2084 0.916626ZM16.2501 17.2083C16.2501 17.7376 15.821 18.1666 15.2917 18.1666H5.70842C5.17914 18.1666 4.75008 17.7376 4.75008 17.2083V6.66663H16.2501V17.2083ZM2.83341 4.74996H18.1667V3.79163C18.1667 3.26235 17.7377 2.83329 17.2084 2.83329H3.79175C3.26248 2.83329 2.83341 3.26235 2.83341 3.79163V4.74996ZM6.66675 15.2916V9.54163C6.66675 9.01235 7.09581 8.58329 7.62508 8.58329C8.15435 8.58329 8.58341 9.01235 8.58341 9.54163V15.2916C8.58341 15.8209 8.15435 16.25 7.62508 16.25C7.09581 16.25 6.66675 15.8209 6.66675 15.2916ZM12.4167 9.54163V15.2916C12.4167 15.8209 12.8458 16.25 13.3751 16.25C13.9044 16.25 14.3334 15.8209 14.3334 15.2916V9.54163C14.3334 9.01235 13.9044 8.58329 13.3751 8.58329C12.8458 8.58329 12.4167 9.01235 12.4167 9.54163Z",
    fill: "#646469"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape);
export default __webpack_public_path__ + "static/media/Shape.2bf87e39af7494a9b9c69d122be4a76b.svg";
export { ForwardRef as ReactComponent };